// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1__c429dec45509a8608645","cls2":"AuthorHeader-cls2___b0a2f715eb61650614e AuthorHeader-cls1__c429dec45509a8608645"};